module.exports = __webpack_public_path__ + "img/upgrade1.9b13c057.png";